// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"format-horizontal-align-top"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M5 3L5 21M12 3L12 15M19 3L19 21","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const FormatHorizontalAlignTopIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'format-horizontal-align-top',
    ref,
    icon: element,
  },
));

FormatHorizontalAlignTopIcon.displayName = 'FormatHorizontalAlignTopIcon';

export default FormatHorizontalAlignTopIcon;
